var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget',{attrs:{"title":"Drop Ships"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"centered large count"},[_vm._v(_vm._s(_vm.dropShips.count))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }